import { useAppStore } from 'state/store';
import type { FaqEdge, NoticeEdge } from 'types/support';

export const NoticeModalActions = {
	setClose: (close: boolean) => useAppStore.getState().setModalClose(close),
	setCloseBanner: (close: boolean) => useAppStore.getState().setBannerClose(close)
};

export const PublicDataActions = {
	setServiceGuideLink: (link: string) => useAppStore.getState().setServiceGuideLink(link),
	serServiceIntrodueLink: (language: string) => useAppStore.getState().setServiceIntroduceLink(language),
	setChanneltalk: (link: string) => useAppStore.getState().setChanneltalk(link),
	setCloseWhileADay: (close: boolean) => useAppStore.getState().setCloseWhileADay(close),
	setCloseBannerForever: (close: boolean) => useAppStore.getState().setCloseBannerForever(close)
};

export const SignatureActions = {
	setExist: (exist: boolean) => useAppStore.getState().setSignatureExist(exist),
	setImage: (image: string) => useAppStore.getState().setSignatureImage(image),
	setProcess: (process: number) => useAppStore.getState().setSignatureProcess(process)
};

export const SupportActions = {
	setSupportTab: (tab: number) => useAppStore.getState().setSupportTab(tab),
	setKeyword: (keyword: string | null) => useAppStore.getState().setKeyword(keyword),
	setNoticeData: (data: NoticeEdge[] | null) => useAppStore.getState().setNoticeData(data),
	setNoticeId: (id: string | number | null) => useAppStore.getState().setNoticeId(id),
	setNoticeCategory: (category: number) => useAppStore.getState().setNoticeCategory(category),
	setFaqData: (data: FaqEdge[] | null) => useAppStore.getState().setFaqData(data),
	setFaqCategory: (category: number) => useAppStore.getState().setFaqCategory(category),
	setFaqCategoryList: (categoryList: [string, number][]) => useAppStore.getState().setFaqCategoryList(categoryList)
};
